// extracted by mini-css-extract-plugin
module.exports = {"item":"NoteItem_item__2L63e","image":"NoteItem_image__2L_gK","content":"NoteItem_content__2xlB3","actions":"NoteItem_actions__3QH_J","myButton":"NoteItem_myButton__3J2Be"};